(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.promutuel_socialShareButton = {
    attach: function attach(context) {

      /**
       * Toggle pop-up.
       */
       $(once('promutuelSocialShareButton', '.js-share-btn', context)).each(function() {
        const container = this.parentElement;
        this.addEventListener('click', function (event) {
          container.classList.toggle('social-share-button--popup-on');
          event.preventDefault();
          event.stopPropagation();
        });

        document.body.addEventListener('click', function (event) {
          container.classList.remove('social-share-button--popup-on');
        });
      });

      /**
       * Ensure pop-up is closed when an ancestor with class
       * 'js-share-hide-on-mouseout' is left.
       */
       $(once('promutuelSocialShareButton', '.js-share-hide-on-mouseout', context)).each(function() {
        this.addEventListener('mouseleave', function (event) {
          this.querySelectorAll('.js-share-btn').forEach(element => {
            element.parentElement.classList.remove('social-share-button--popup-on');
          });
        });
      });

    }
  };
})(jQuery, Drupal, once);
